export const ufMembraneProducts = {
  'uf-module-hm90': {
    title: 'UF Module HM90',
    category: 'UF Membrane Series',
    description: 'Advanced ultrafiltration module with hollow fiber technology for superior water treatment.',
    longDescription: 'UF Module HM90 is a high-performance ultrafiltration system featuring advanced hollow fiber membrane technology. Available in multiple material options (PAN, PS, PP, PVDF), it offers flexible filtration methods including inside-out and outside-in configurations. The module provides excellent removal of microorganisms and pathogens while maintaining high water flux rates.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/17e8c9bfbc80f1d74ce160687e2e2235.jpg',
    features: [
      'Multiple hollow fiber materials (PAN, PS, PP, PVDF)',
      'Flexible filtration methods (inside-out, outside-in)',
      'High initial flux rates (>900-1100 L/H)',
      '99.99% microorganism and pathogen removal',
      'Wide pH operating range (3-9 to 2-13)',
      'Durable UPVC housing with epoxy resin end seals'
    ],
    specifications: {
      'Module Size': 'L Φ90X1162mm, S Φ90X678mm',
      'Hollow Fiber ID/OD': '0.4mm-1.6mm / 0.5mm-1.6mm',
      'MWCO (Daltons)': '50k-200k',
      'Membrane Area': 'L-4.5m² S-2.3m², L-14.0m² S-7.0m²',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Connection/Pipe': 'Union connection / PVC Pipe OD. 32mm',
      'Max Feed Pressure': '0.25-0.3mpa',
      'Max Trans-membrane Pressure': '0.15-0.2mpa',
      'Normal Trans-membrane Pressure': '0.01-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h (Large), 20-80L/m²/h (Small)',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Municipal water treatment',
      'Industrial process water',
      'Wastewater treatment and reuse',
      'Food and beverage processing',
      'Pharmaceutical water treatment',
      'Swimming pool water treatment'
    ],
    models: [
      {
        model: 'HM90PAN',
        size: 'L Φ90X1162mm, S Φ90X678mm',
        material: 'PAN',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '50k ~ 100k',
        membraneArea: 'L-4.5m² S-2.3m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>900 (L) >420 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '3-9'
      },
      {
        model: 'HM90PS',
        size: 'L Φ90X1162mm, S Φ90X678mm',
        material: 'PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: 'L-4.5m² S-2.3m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>900 (L) >420 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '2-12'
      },
      {
        model: 'HM90PP',
        size: 'L Φ90X1162mm, S Φ90X678mm',
        material: 'PP',
        fiberIDOD: '0.4mm / 0.5mm',
        mwco: '50k ~ 100k',
        membraneArea: 'L-14.0m² S-7.0m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>1100 (L) >530 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '1-14'
      },
      {
        model: 'HM90PVDF',
        size: 'L Φ90X1162mm, S Φ90X678mm',
        material: 'PVDF',
        fiberIDOD: '0.7mm / 1.3mm',
        mwco: '100k ~ 200k',
        membraneArea: 'L-7.0m² S-3.4m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>1000 (L) >480 (S)',
        maxFeedPressure: '0.25mpa',
        maxTransPressure: '0.15mpa',
        normalTransPressure: '0.01-0.1mpa',
        phRange: '2-13'
      }
    ],
    dimensions: [
      { model: 'HM90PAN', length: '1162mm', diameter: '90mm' },
      { model: 'HM90PS', length: '1162mm', diameter: '90mm' },
      { model: 'HM90PP', length: '1162mm', diameter: '90mm' },
      { model: 'HM90PVDF', length: '1162mm', diameter: '90mm' }
    ]
  },
  'uf-module-hm160': {
    title: 'UF Module HM160',
    category: 'UF Membrane Series',
    description: 'High-capacity ultrafiltration module with enhanced hollow fiber technology for industrial applications.',
    longDescription: 'UF Module HM160 is a high-capacity ultrafiltration system featuring advanced hollow fiber membrane technology with larger diameter housing. Available in multiple material options (PAN, PS, PP, PVDF), it offers flexible filtration methods including inside-out and outside-in configurations. The module provides excellent removal of microorganisms and pathogens while maintaining superior water flux rates for industrial applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e034dca556862a90b9fa228d3c896661.jpg',
    features: [
      'Large capacity with Φ160mm housing diameter',
      'Multiple hollow fiber materials (PAN, PS, PP, PVDF)',
      'Flexible filtration methods (inside-out, outside-in)',
      'High initial flux rates (>4500-5000 L/H)',
      '99.99% microorganism and pathogen removal',
      'Wide pH operating range (3-9 to 2-13)',
      'Durable UPVC housing with epoxy resin end seals'
    ],
    specifications: {
      'Module Size': 'Φ160X1352mm',
      'Hollow Fiber ID/OD': '0.4mm-1.6mm / 0.5mm-1.6mm',
      'MWCO (Daltons)': '50k-200k',
      'Membrane Area': '15m²-40m²',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Connection/Pipe': 'Union connection / PVC Pipe OD. 40mm',
      'Max Feed Pressure': '0.25-0.3mpa',
      'Max Trans-membrane Pressure': '0.15-0.2mpa',
      'Normal Trans-membrane Pressure': '0.01-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h (HM160PAN/PS), 20-80L/m²/h (HM160PP/PVDF)',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Large-scale municipal water treatment',
      'Industrial process water treatment',
      'Wastewater treatment and reuse',
      'Food and beverage processing',
      'Pharmaceutical water treatment',
      'Swimming pool and recreational water treatment'
    ],
    models: [
      {
        model: 'HM160PAN',
        size: 'Φ160X1352mm',
        material: 'PAN',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '50k ~ 100k',
        membraneArea: '15m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>4500',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '3-9'
      },
      {
        model: 'HM160PS',
        size: 'Φ160X1352mm',
        material: 'PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '15m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>4500',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '2-12'
      },
      {
        model: 'HM160PP',
        size: 'Φ160X1352mm',
        material: 'PP',
        fiberIDOD: '0.4mm / 0.5mm',
        mwco: '50k ~ 100k',
        membraneArea: '40m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>5000',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '1-14'
      },
      {
        model: 'HM160PVDF',
        size: 'Φ160X1352mm',
        material: 'PVDF',
        fiberIDOD: '0.7mm / 1.3mm',
        mwco: '100k ~ 200k',
        membraneArea: '23m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>4900',
        maxFeedPressure: '0.25mpa',
        maxTransPressure: '0.15mpa',
        normalTransPressure: '0.01-0.1mpa',
        phRange: '2-13'
      }
    ],
    dimensions: [
      { model: 'HM160PAN', length: '1352mm', diameter: '160mm' },
      { model: 'HM160PS', length: '1352mm', diameter: '160mm' },
      { model: 'HM160PP', length: '1352mm', diameter: '160mm' },
      { model: 'HM160PVDF', length: '1352mm', diameter: '160mm' }
    ]
  },
  'uf-module-hm200': {
    title: 'UF Module HM200',
    category: 'UF Membrane Series',
    description: 'Ultra-high capacity ultrafiltration module with advanced hollow fiber technology for large-scale industrial applications.',
    longDescription: 'UF Module HM200 is an ultra-high capacity ultrafiltration system featuring the most advanced hollow fiber membrane technology with the largest diameter housing (Φ200mm). Available in multiple material options (PAN, PS, PP, PVDF), it offers flexible filtration methods including inside-out and outside-in configurations. The module provides excellent removal of microorganisms and pathogens while maintaining exceptional water flux rates for large-scale industrial and municipal applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/326417d4cf873a18baa232de5a630fd1.jpg',
    features: [
      'Ultra-high capacity with Φ200mm housing diameter',
      'Multiple hollow fiber materials (PAN, PS, PP, PVDF)',
      'Flexible filtration methods (inside-out, outside-in)',
      'Ultra-high initial flux rates (>6500-7100 L/H)',
      '99.99% microorganism and pathogen removal',
      'Wide pH operating range (3-9 to 2-13)',
      'Durable UPVC housing with epoxy resin end seals'
    ],
    specifications: {
      'Module Size': 'L Φ200X1465mm, S Φ200X1405mm',
      'Hollow Fiber ID/OD': '0.4mm-1.6mm / 0.5mm-1.6mm',
      'MWCO (Daltons)': '50k-200k',
      'Membrane Area': 'L-27m² S-25m², L-55m² S-50m²',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Connection/Pipe': 'Union connection / PVC Pipe OD. 50mm',
      'Max Feed Pressure': '0.25-0.3mpa',
      'Max Trans-membrane Pressure': '0.15-0.2mpa',
      'Normal Trans-membrane Pressure': '0.01-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h (HM200PAN/PS), 20-80L/m²/h (HM200PP/PVDF)',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Large-scale municipal water treatment plants',
      'Industrial process water treatment',
      'Wastewater treatment and reuse facilities',
      'Food and beverage processing industries',
      'Pharmaceutical water treatment systems',
      'Swimming pool and recreational water treatment'
    ],
    models: [
      {
        model: 'HM200PAN',
        size: 'L Φ200X1465mm, S Φ200X1405mm',
        material: 'PAN',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '50k ~ 100k',
        membraneArea: 'L-27m² S-25m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>6500 (L) >6000 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '3-9'
      },
      {
        model: 'HM200PS',
        size: 'L Φ200X1405mm, S Φ200X1405mm',
        material: 'PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: 'L-27m² S-25m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>6500 (L) >6000 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '2-12'
      },
      {
        model: 'HM200PP',
        size: 'L Φ200X1465mm, S Φ200X1405mm',
        material: 'PP',
        fiberIDOD: '0.4mm / 0.5mm',
        mwco: '50k ~ 100k',
        membraneArea: 'L-55m² S-50m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>7100 (L) >6600 (S)',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '1-14'
      },
      {
        model: 'HM200PVDF',
        size: 'L Φ200X1465mm, S Φ200X1405mm',
        material: 'PVDF',
        fiberIDOD: '0.7mm / 1.3mm',
        mwco: '100k ~ 200k',
        membraneArea: 'L-40m² S-37m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>7000 (L) >6500 (S)',
        maxFeedPressure: '0.25mpa',
        maxTransPressure: '0.15mpa',
        normalTransPressure: '0.01-0.1mpa',
        phRange: '2-13'
      }
    ],
    dimensions: [
      { model: 'HM200PAN', length: '1465mm', diameter: '200mm' },
      { model: 'HM200PS', length: '1405mm', diameter: '200mm' },
      { model: 'HM200PP', length: '1465mm', diameter: '200mm' },
      { model: 'HM200PVDF', length: '1465mm', diameter: '200mm' }
    ]
  },
  'uf-module-hm200-1': {
    title: 'UF Module HM200-1',
    category: 'UF Membrane Series',
    description: 'Ultra-high capacity ultrafiltration module with advanced hollow fiber technology and enhanced design for large-scale industrial applications.',
    longDescription: 'UF Module HM200-1 is an enhanced ultra-high capacity ultrafiltration system featuring the most advanced hollow fiber membrane technology with optimized Φ200mm housing design. Available in multiple material options (PAN, PS, PP, PVDF), it offers flexible filtration methods including inside-out and outside-in configurations. The module provides excellent removal of microorganisms and pathogens while maintaining exceptional water flux rates with improved efficiency for large-scale industrial and municipal applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/193e86f76dafac5b4338e76b247cfd86.jpg',
    features: [
      'Enhanced ultra-high capacity with Φ200mm housing diameter',
      'Multiple hollow fiber materials (PAN, PS, PP, PVDF)',
      'Flexible filtration methods (inside-out, outside-in)',
      'Exceptional initial flux rates (>6500-7100 L/H)',
      '99.99% microorganism and pathogen removal',
      'Wide pH operating range (3-9 to 2-13)',
      'Durable UPVC housing with epoxy resin end seals',
      'Coupling connection DN50 for enhanced flow capacity'
    ],
    specifications: {
      'Module Size': 'Φ200X1450mm',
      'Hollow Fiber ID/OD': '0.4mm-1.6mm / 0.5mm-1.6mm',
      'MWCO (Daltons)': '50k-200k',
      'Membrane Area': '27m²-55m²',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Connection/Pipe': 'Coupling connection DN50 / PVC Pipe ID. 50mm',
      'Max Feed Pressure': '0.25-0.3mpa',
      'Max Trans-membrane Pressure': '0.15-0.2mpa',
      'Normal Trans-membrane Pressure': '0.01-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h (HM200-1PAN/PS), 20-80L/m²/h (HM200-1PP/PVDF)',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Large-scale municipal water treatment plants',
      'Industrial process water treatment',
      'Wastewater treatment and reuse facilities',
      'Food and beverage processing industries',
      'Pharmaceutical water treatment systems',
      'Swimming pool and recreational water treatment'
    ],
    models: [
      {
        model: 'HM200-1PAN',
        size: 'Φ200X1450mm',
        material: 'PAN',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '50k ~ 100k',
        membraneArea: '27m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>6500',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '3-9'
      },
      {
        model: 'HM200-1PS',
        size: 'Φ200X1450mm',
        material: 'PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '27m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>6500',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '2-12'
      },
      {
        model: 'HM200-1PP',
        size: 'Φ200X1450mm',
        material: 'PP',
        fiberIDOD: '0.4mm / 0.5mm',
        mwco: '50k ~ 100k',
        membraneArea: '55m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>7100',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '1-14'
      },
      {
        model: 'HM200-1PVDF',
        size: 'Φ200X1450mm',
        material: 'PVDF',
        fiberIDOD: '0.7mm / 1.3mm',
        mwco: '100k ~ 200k',
        membraneArea: '40m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>7000',
        maxFeedPressure: '0.25mpa',
        maxTransPressure: '0.15mpa',
        normalTransPressure: '0.01-0.1mpa',
        phRange: '2-13'
      }
    ],
    dimensions: [
      { model: 'HM200-1PAN', length: '1450mm', diameter: '200mm' },
      { model: 'HM200-1PS', length: '1450mm', diameter: '200mm' },
      { model: 'HM200-1PP', length: '1450mm', diameter: '200mm' },
      { model: 'HM200-1PVDF', length: '1450mm', diameter: '200mm' }
    ]
  },
  'uf-module-hm250': {
    title: 'UF Module HM250',
    category: 'UF Membrane Series',
    description: 'Maximum capacity ultrafiltration module with state-of-the-art hollow fiber technology for the largest industrial applications.',
    longDescription: 'UF Module HM250 is the ultimate ultra-high capacity ultrafiltration system featuring the most advanced hollow fiber membrane technology with the largest diameter housing (Φ250mm). Available in multiple material options (PAN, PS, PP, PVDF), it offers flexible filtration methods including inside-out and outside-in configurations. The module provides excellent removal of microorganisms and pathogens while maintaining the highest water flux rates for the most demanding large-scale industrial and municipal applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/0b46980fb4ab0c3c817990082b81a6eb.jpg',
    features: [
      'Maximum capacity with Φ250mm housing diameter',
      'Multiple hollow fiber materials (PAN, PS, PP, PVDF)',
      'Flexible filtration methods (inside-out, outside-in)',
      'Ultra-high initial flux rates (>11000-15300 L/H)',
      '99.99% microorganism and pathogen removal',
      'Wide pH operating range (3-9 to 2-13)',
      'Durable UPVC housing with epoxy resin end seals',
      'Coupling connection DN50 for maximum flow capacity'
    ],
    specifications: {
      'Module Size': 'Φ250X1713mm',
      'Hollow Fiber ID/OD': '0.4mm-1.6mm / 0.5mm-1.6mm',
      'MWCO (Daltons)': '50k-200k',
      'Membrane Area': '48m²-100m²',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Connection/Pipe': 'Coupling connection DN50 / PVC Pipe ID. 50mm',
      'Max Feed Pressure': '0.25-0.3mpa',
      'Max Trans-membrane Pressure': '0.15-0.2mpa',
      'Normal Trans-membrane Pressure': '0.01-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h (HM250PAN/PS), 20-80L/m²/h (HM250PP/PVDF)',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Largest-scale municipal water treatment plants',
      'Major industrial process water treatment',
      'Large wastewater treatment and reuse facilities',
      'Industrial food and beverage processing',
      'Large pharmaceutical water treatment systems',
      'Commercial swimming pool and recreational water treatment'
    ],
    models: [
      {
        model: 'HM250PAN',
        size: 'Φ250X1713mm',
        material: 'PAN',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '50k ~ 100k',
        membraneArea: '48m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>11000',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '3-9'
      },
      {
        model: 'HM250PS',
        size: 'Φ250X1713mm',
        material: 'PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '48m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>11000',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '2-12'
      },
      {
        model: 'HM250PP',
        size: 'Φ250X1713mm',
        material: 'PP',
        fiberIDOD: '0.4mm / 0.5mm',
        mwco: '50k ~ 100k',
        membraneArea: '100m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>15300',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: '1-14'
      },
      {
        model: 'HM250PVDF',
        size: 'Φ250X1713mm',
        material: 'PVDF',
        fiberIDOD: '0.7mm / 1.3mm',
        mwco: '100k ~ 200k',
        membraneArea: '76m²',
        filtrationMethod: 'Outside-in',
        initialFlux: '>15000',
        maxFeedPressure: '0.25mpa',
        maxTransPressure: '0.15mpa',
        normalTransPressure: '0.01-0.1mpa',
        phRange: '2-13'
      }
    ],
    dimensions: [
      { model: 'HM250PAN', length: '1713mm', diameter: '250mm' },
      { model: 'HM250PS', length: '1713mm', diameter: '250mm' },
      { model: 'HM250PP', length: '1713mm', diameter: '250mm' },
      { model: 'HM250PVDF', length: '1713mm', diameter: '250mm' }
    ]
  },
  'uf-module-4021-4040-8040': {
    title: 'UF Module UF-4021/4040/8040',
    category: 'UF Membrane Series',
    description: 'Standard ultrafiltration modules with hollow fiber technology in industry-standard dimensions.',
    longDescription: 'UF Module UF-4021/4040/8040 series offers standard ultrafiltration solutions with hollow fiber membrane technology in industry-standard dimensions. Available in PAN and PS materials, these modules provide inside-out filtration with high initial flux rates and excellent microorganism removal. The standardized dimensions make them compatible with existing industrial filtration systems.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5e7042e15883c8c9523c3e6dd27aebd7.jpg',
    features: [
      'Industry-standard dimensions (4021, 4040, 8040)',
      'Hollow fiber materials: PAN and PS',
      'Inside-out filtration method',
      'High initial flux rates (>400-5000 L/H)',
      '99.99% microorganism and pathogen removal',
      'Compatible with existing industrial systems',
      'Durable UPVC housing with epoxy resin end seals'
    ],
    specifications: {
      'Module Sizes': 'Φ101X533mm, Φ101X1016mm, Φ201X1016mm',
      'Hollow Fiber Material': 'PAN / PS',
      'Hollow Fiber ID/OD': '1.0mm / 1.6mm',
      'MWCO (Daltons)': '10k ~ 100k',
      'Membrane Area': '1.9m² - 19m²',
      'Filtration Method': 'Inside-out',
      'Housing Material': 'UPVC',
      'End Seal Material': 'Epoxy resins',
      'Max Feed Pressure': '0.3mpa',
      'Max Trans-membrane Pressure': '0.2mpa',
      'Normal Trans-membrane Pressure': '0.02-0.15mpa',
      'Feed Turbidity': '<50ntu',
      'Permeate Turbidity': '<0.1ntu',
      'Max Working Temperature': '5-45°C'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1mpa',
      'Feed Water': 'Pure water',
      'Designed Water Flux': '40-120L/m²/h',
      'Microorganism Removal': '99.99%'
    },
    applications: [
      'Municipal water treatment',
      'Industrial process water',
      'Wastewater treatment and reuse',
      'Food and beverage processing',
      'Pharmaceutical water treatment',
      'Swimming pool water treatment'
    ],
    models: [
      {
        model: 'UF-4021',
        size: 'Φ101X533mm',
        material: 'PAN / PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '1.9m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>400',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: 'PAN: 3-9, PS: 2-12'
      },
      {
        model: 'UF-4040',
        size: 'Φ101X1016mm',
        material: 'PAN / PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '3.8m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>800',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: 'PAN: 3-9, PS: 2-12'
      },
      {
        model: 'UF-8040',
        size: 'Φ201X1016mm',
        material: 'PAN / PS',
        fiberIDOD: '1.0mm / 1.6mm',
        mwco: '10k ~ 100k',
        membraneArea: '19m²',
        filtrationMethod: 'Inside-out',
        initialFlux: '>5000',
        maxFeedPressure: '0.3mpa',
        maxTransPressure: '0.2mpa',
        normalTransPressure: '0.02-0.15mpa',
        phRange: 'PAN: 3-9, PS: 2-12'
      }
    ],
    dimensions: [
      { model: 'UF-4021', length: '533mm', diameter: '101mm' },
      { model: 'UF-4040', length: '1016mm', diameter: '101mm' },
      { model: 'UF-8040', length: '1016mm', diameter: '201mm' }
    ]
  },
  'uf-sfp2860-2880': {
    title: 'Hollow Fiber Ultrafiltration Membrane Module UF-SFP2860/2880',
    category: 'UF Membrane Series',
    description: 'Advanced hollow fiber ultrafiltration membrane modules using PVDF material with unique anti-oxidation and anti-pollution characteristics.',
    longDescription: 'The hollow fiber UF membrane uses PVDF as raw material, made of advanced production technology with its own intellectual property rights. The membrane has high strength, it also has unique anti-oxidation, anti-pollution and easy-to-clean characteristics, which can effectively filter bacteria, colloids, suspended solids, rust, macromolecular organic substances and other substances in water.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/a1c47eb4445881344c4aedfcd90437dc.jpg',
    features: [
      'PVDF raw material with advanced production technology',
      'High strength membrane with intellectual property rights',
      'Unique anti-oxidation and anti-pollution characteristics',
      'Easy-to-clean properties for maintenance efficiency',
      'Effective filtration of bacteria, colloids, and suspended solids',
      'External pressure type filtration method',
      'Full flow or cross flow filtration operation modes'
    ],
    specifications: {
      'Membrane Material': 'Polyvinylidene fluoride (PVDF)',
      'Membrane Aperture': '0.03 μm',
      'Hollow Fiber ID/OD': '0.7 / 1.3 mm',
      'Housing Material': 'Polyvinyl chloride (UPVC)',
      'Fiber Bonding Material': 'Epoxy resin',
      'Suspended Matter Removal': '100%',
      'Water Turbidity': '≤0.2 NTU',
      'Water Production SDI': '≤0.2',
      'Guaranteed Age': '3-5 year (Except for special water quality)',
      'Filtration Method': 'External pressure type',
      'Component Maximum Inlet Pressure': '≤0.3 MPa',
      'Recommended Normal Operating Pressure': '≤0.15 MPa',
      'Max Transmembrane Pressure Difference': '0.2 MPa',
      'Operating Temperature': '5-45°C',
      'pH Range When in Use': '2-11 (pH range 1-12 during cleaning)',
      'Pretreatment Accuracy Requirements': '<150 μm',
      'Max Influent Turbidity': '≤50 NTU, Maximum bearing 300',
      'Raw Water Oil Content': '<2 mg/L',
      'Max Influent Residual Chlorine Concentration': '200 mg/L (Cleaning agent maximum residual chlorine concentration 5000 mg/L)',
      'Filter Flux Range': '45-100 L/m²·h - 0.1 MPa 25°C (Selected according to the influent water quality)',
      'Operating Mode': 'Full flow or cross flow filtration'
    },
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.1 MPa',
      'Feed Water': 'Pure water',
      'UF-SFP2860 Membrane Area': '55 m²',
      'UF-SFP2880 Membrane Area': '75 m²',
      'Microorganism Removal': '100%'
    },
    applications: [
      'Water quality improvement projects',
      'Dongying boiler water supply projects',
      'Municipal water treatment',
      'Industrial process water treatment',
      'Wastewater treatment and reuse',
      'Food and beverage processing',
      'Pharmaceutical water treatment'
    ],
    models: [
      {
        model: 'UF-SFP2860',
        membraneArea: '55 m²',
        dimensions: {
          a: '1860 mm',
          b: '1725 mm',
          c: '95 mm',
          d: '225 mm',
          e: '180 mm'
        },
        material: 'Polyvinylidene fluoride (PVDF)',
        aperture: '0.03 μm',
        fiberIDOD: '0.7 / 1.3 mm',
        housingMaterial: 'Polyvinyl chloride (UPVC)',
        filtrationMethod: 'External pressure type',
        maxInletPressure: '≤0.3 MPa',
        operatingPressure: '≤0.15 MPa',
        maxTransPressure: '0.2 MPa',
        operatingTemp: '5-45°C',
        phRange: '2-11 (pH range 1-12 during cleaning)',
        fluxRange: '45-100 L/m²·h - 0.1 MPa 25°C'
      },
      {
        model: 'UF-SFP2880',
        membraneArea: '75 m²',
        dimensions: {
          a: '2360 mm',
          b: '2225 mm',
          c: '95 mm',
          d: '225 mm',
          e: '180 mm'
        },
        material: 'Polyvinylidene fluoride (PVDF)',
        aperture: '0.03 μm',
        fiberIDOD: '0.7 / 1.3 mm',
        housingMaterial: 'Polyvinyl chloride (UPVC)',
        filtrationMethod: 'External pressure type',
        maxInletPressure: '≤0.3 MPa',
        operatingPressure: '≤0.15 MPa',
        maxTransPressure: '0.2 MPa',
        operatingTemp: '5-45°C',
        phRange: '2-11 (pH range 1-12 during cleaning)',
        fluxRange: '45-100 L/m²·h - 0.1 MPa 25°C'
      }
    ],
    dimensions: [
      { 
        model: 'UF-SFP2860', 
        length: '1860mm', 
        width: '1725mm',
        height: '95mm',
        inletDiameter: '225mm',
        outletDiameter: '180mm'
      },
      { 
        model: 'UF-SFP2880', 
        length: '2360mm', 
        width: '2225mm',
        height: '95mm',
        inletDiameter: '225mm',
        outletDiameter: '180mm'
      }
    ],
    processFlow: {
      description: 'Complete process flow chart showing water treatment stages from raw water input to concentrated water discharge',
      components: [
        'Product water valve',
        'Upper valve',
        'Backwash tank',
        'Chemical cleaning pump',
        'Chemical cleaning tank',
        'Oil-free compressed air valve',
        'Lower valve',
        'Inlet valve',
        'Concentrated water discharge'
      ]
    }
  }
};

export const ufMembraneProductsList = [
  {
    id: 'uf-module-hm90',
    name: 'UF Module HM90',
    category: 'UF Membrane Series',
    description: 'Advanced ultrafiltration module with hollow fiber technology',
    features: ['Multiple material options', 'High flux rates', '99.99% pathogen removal'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/17e8c9bfbc80f1d74ce160687e2e2235.jpg'
  },
  {
    id: 'uf-module-hm160',
    name: 'UF Module HM160',
    category: 'UF Membrane Series',
    description: 'High-capacity ultrafiltration module for industrial applications',
    features: ['Large capacity design', 'Enhanced hollow fiber technology', 'Superior flux rates'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e034dca556862a90b9fa228d3c896661.jpg'
  },
  {
    id: 'uf-module-hm200',
    name: 'UF Module HM200',
    category: 'UF Membrane Series',
    description: 'Ultra-high capacity ultrafiltration module for large-scale industrial applications',
    features: ['Ultra-high capacity design', 'Advanced hollow fiber technology', 'Exceptional flux rates'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/326417d4cf873a18baa232de5a630fd1.jpg'
  },
  {
    id: 'uf-module-hm200-1',
    name: 'UF Module HM200-1',
    category: 'UF Membrane Series',
    description: 'Enhanced ultra-high capacity ultrafiltration module with optimized design',
    features: ['Enhanced ultra-high capacity', 'Optimized design', 'Coupling connection DN50'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/193e86f76dafac5b4338e76b247cfd86.jpg'
  },
  {
    id: 'uf-module-hm250',
    name: 'UF Module HM250',
    category: 'UF Membrane Series',
    description: 'Maximum capacity ultrafiltration module for the largest industrial applications',
    features: ['Maximum capacity design', 'State-of-the-art technology', 'Highest flux rates'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/0b46980fb4ab0c3c817990082b81a6eb.jpg'
  },
  {
    id: 'uf-module-4021-4040-8040',
    name: 'UF Module UF-4021/4040/8040',
    category: 'UF Membrane Series',
    description: 'Standard ultrafiltration modules with hollow fiber technology in industry-standard dimensions',
    features: ['Industry-standard dimensions', 'PAN/PS materials', 'Compatible with existing systems'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5e7042e15883c8c9523c3e6dd27aebd7.jpg'
  },
  {
    id: 'uf-sfp2860-2880',
    name: 'UF-SFP2860/2880',
    category: 'UF Membrane Series',
    description: 'Advanced hollow fiber ultrafiltration membrane modules using PVDF material',
    features: ['PVDF material with high strength', 'Anti-oxidation and anti-pollution', 'External pressure type filtration'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/a1c47eb4445881344c4aedfcd90437dc.jpg'
  }
];